import guestNavigation from './guest-navigation'

// ===========================|| MENU ITEMS ||=========================== //

const menuItems = {
  items: [guestNavigation]
}

export default menuItems
